
import { Routes, Route } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import ClientList from "@/components/clients/ClientList";
import { MockDataButton } from "@/components/clients/MockDataButton";
import { Separator } from "@/components/ui/separator";
import { ClientStats } from "@/components/clients/ClientStats";
import { ClientsEmptyState } from "@/components/empty-states/ClientsEmptyState";
import ClientDetail from "./ClientDetail";
import { useClients } from "@/hooks/useClients";
import { useState } from "react";

const ClientsMain = () => {
  const { data: clients = [], isLoading } = useClients();
  const [showAddClientForm, setShowAddClientForm] = useState(false);

  const handleAddClient = () => {
    setShowAddClientForm(true);
    // TODO: Implement add client form/dialog
    console.log('Add client clicked');
  };

  if (!isLoading && clients.length === 0) {
    return (
      <div className="w-full space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Client Management</h1>
            <p className="text-muted-foreground mt-1">
              Manage your client relationships, track jobs, and monitor engagement
            </p>
          </div>
          <MockDataButton onSuccess={() => window.location.reload()} />
        </div>
        
        <Separator />
        
        <ClientsEmptyState onAddClient={handleAddClient} />
      </div>
    );
  }

  return (
    <div className="w-full space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Client Management</h1>
          <p className="text-muted-foreground mt-1">
            Manage your client relationships, track jobs, and monitor engagement
          </p>
        </div>
        <MockDataButton onSuccess={() => window.location.reload()} />
      </div>
      
      <Separator />
      
      <ClientStats />
      
      <Card className="w-full">
        <CardHeader className="pb-3">
          <CardTitle>Clients Overview</CardTitle>
        </CardHeader>
        <CardContent>
          <ClientList />
        </CardContent>
      </Card>
    </div>
  );
};

const Clients = () => {
  return (
    <Routes>
      <Route path="/" element={<ClientsMain />} />
      <Route path="/:id" element={<ClientDetail />} />
    </Routes>
  );
};

export default Clients;
